import React from "react";
import { IconButton, Badge, Tooltip } from "@mui/material";
import { Notifications as NotificationsIcon } from "@mui/icons-material";
import { useNotifications } from "../contexts/NotificationContext";

interface NotificationHeaderProps {
  onNotificationClick: () => void;
}

const NotificationHeader: React.FC<NotificationHeaderProps> = ({
  onNotificationClick,
}) => {
  const { unreadCount } = useNotifications();

  // Só mostra o ícone se houver notificações não lidas
  if (unreadCount === 0) {
    return null;
  }

  return (
    <Tooltip
      title={`${unreadCount} notificação${unreadCount > 1 ? "ões" : ""} não lida${unreadCount > 1 ? "s" : ""}`}
    >
      <IconButton
        color="inherit"
        onClick={onNotificationClick}
        size="medium"
        sx={{
          mr: 1,
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.08)",
          },
        }}
      >
        <Badge
          badgeContent={unreadCount}
          color="error"
          max={99}
          sx={{
            "& .MuiBadge-badge": {
              fontSize: "0.75rem",
              height: 20,
              minWidth: 20,
            },
          }}
        >
          <NotificationsIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default NotificationHeader;
